import { extendTheme } from '@chakra-ui/react'
import { colors } from './colors'
import { InputTheme as Input } from './Input'
import { SelectTheme as Select } from './Select'
import { ButtonTheme as Button } from './Button'
import { LinkTheme as Link } from './Link'
import { HeadingTheme as Heading } from './Heading'
import { DividerTheme as Divider } from './Divider'
import { AlertTheme as Alert } from './Alert'
import { ModalTheme as Modal } from './Modal'

export const BaseTheme = extendTheme({
  colors,
  styles: {
    global: {
      'html, body, #root': {
        height: '100%',
        fontWeight: 500,
      },
    },
  },
  semanticTokens: {
    colors: {
      'chakra-body-text': { _light: 'brand.fontColor', _dark: 'brand.white' },
      'chakra-placeholder-color': 'brand.formPlaceholderColor',
    },
  },
  fonts: {
    body: 'univia-pro, sans-serif',
    heading: 'univia-pro, sans-serif'
  },
  components: {
    Alert,
    Input,
    Select,
    Button,
    Link,
    Heading,
    Divider,
    Modal
  }
})